import { analytics } from 'lib/analytics/analytics';

/**
 * Our own server route that starts the GovX ID OAuth (explicit) flow. It mints
 * the CSRF state server-side, redirects to GovX, and on successful verification
 * mints a single-use Shopify discount code (see app/api/govx/*).
 */
export const GOVX_AUTHORIZE_PATH = '/api/govx/authorize';

export type GovxSurface = 'heroes' | 'buy';

/**
 * `returnTo` is where success (buy page) and failure (modal reopens) land.
 * Logs the click and the verify start (Vercel + GTM dataLayer).
 */
export const openGovxVerify = (
  surface: GovxSurface,
  region: string | undefined | null,
  returnTo?: string,
): void => {
  analytics.track('govx_verify_click', { surface, region: region ?? '' });
  analytics.track('hero_verify_start', {
    region: region ?? '',
    surface,
    category: 'veterans',
    provider: 'govx',
  });
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams();
    if (region) params.set('region', region);
    if (returnTo) params.set('returnTo', returnTo);
    const qs = params.toString();
    window.location.assign(`${GOVX_AUTHORIZE_PATH}${qs ? `?${qs}` : ''}`);
  }
};
